<!--
  创建时间：2024/8/21 16:58
  创建人：toyehuang
  文件描述：LoginEntry 登录入口
-->

<template>
  <div class="login-entry">
    <block-head-line title="登录入口" :hidMoreBtn="true" />
    <ul class="f-b-c mt-20">
      <li>
        <a
          rel="noreferrer"
          href=""
          title="资产交易"
          @click.prevent="() => (dialogVisiblejy = true)"
        >
          <img src="@/assets/images/home/zichuanjy.png" alt="资产交易" />
          <span>资产交易</span>
        </a>
      </li>
      <li>
        <a
          rel="noreferrer"
          href=""
          title="招标采购"
          @click.prevent="() => (dialogVisiblecg = true)"
        >
          <img src="@/assets/images/home/caigoupt.png" alt="招标采购" />
          <span>招标采购</span>
        </a>
      </li>
      <li>
        <a
          rel="noreferrer"
          :href="dljgEntryLink"
          title="服务中心"
          target="_blank"
        >
          <img src="@/assets/images/home/fuwuzx.jpg" alt="服务中心" />
          <span>服务中心</span>
        </a>
      </li>
      <li>
        <a :href="zjzcEntryLink" title="专家注册" target="_blank">
          <img src="@/assets/images/home/login-hui.png" alt="专家注册" />
          <span>专家注册</span>
        </a>
      </li>
      <li>
        <a
          rel="noreferrer"
          href=""
          title="免费注册"
          @click.prevent="() => (dialogVisibleRegister = true)"
        >
          <img src="@/assets/images/home/caozuozn.png" alt="免费注册" />
          <span>免费注册</span>
        </a>
      </li>
    </ul>
    <el-dialog
      title="选择相应系统登录"
      :visible.sync="dialogVisiblejy"
      custom-class="login-entry-dialog"
      width="530px"
      top="25vh"
    >
      <div class="login-entry-pop f-c">
        <a
          rel="noreferrer"
          :href="jgEntryLink"
          title="机构登录"
          target="_blank"
          class="login-entry-pop-item mr-20"
        >
          <h3>机构登录</h3>
          <div class="hover-txt-box f-b-c">
            <span>机构登录</span>
          </div>
        </a>
        <a
          rel="noreferrer"
          :href="hyEntryLinkjy"
          title="会员登录"
          target="_blank"
          class="login-entry-pop-item"
        >
          <h3>会员登录</h3>
          <div class="hover-txt-box f-b-c">
            <span>会员登录</span>
          </div>
        </a>
      </div>
    </el-dialog>
    <el-dialog
      title="选择相应系统登录"
      :visible.sync="dialogVisiblecg"
      custom-class="login-entry-dialog"
      width="710px"
      top="25vh"
    >
      <div class="login-entry-pop f-c">
        <a
          rel="noreferrer"
          :href="cgrEntryLink"
          title="采购人"
          target="_blank"
          class="login-entry-pop-item1 mr-20"
        >
          <h3>采购人</h3>
          <div class="hover-txt-box f-b-c">
            <span>采购人</span>
          </div>
        </a>
        <a
          rel="noreferrer"
          :href="gysEntryLink"
          title="供应商"
          target="_blank"
          class="login-entry-pop-item1 mr-20"
        >
          <h3>供应商</h3>
          <div class="hover-txt-box f-b-c">
            <span>供应商</span>
          </div>
        </a>
        <!-- <a
          rel="noreferrer"
          :href="dljgEntryLink"
          title="服务中心"
          target="_blank"
          class="login-entry-pop-item1 mr-20"
        >
          <h3>服务中心</h3>
          <div class="hover-txt-box f-b-c">
            <span>服务中心</span>
          </div>
        </a> -->
        <a
          rel="noreferrer"
          :href="zjEntryLink"
          title="专家"
          target="_blank"
          class="login-entry-pop-item1"
        >
          <h3>专家</h3>
          <div class="hover-txt-box f-b-c">
            <span>专家</span>
          </div>
        </a>
      </div>
    </el-dialog>
    <el-dialog
      title="选择相应系统登录"
      :visible.sync="dialogVisiblezy"
      custom-class="login-entry-dialog"
      width="530px"
      top="25vh"
    >
      <div class="login-entry-pop f-c">
        <a
          rel="noreferrer"
          :href="jgEntryLink"
          title="机构登录"
          target="_blank"
          class="login-entry-pop-item mr-20"
        >
          <h3>机构登录</h3>
          <div class="hover-txt-box f-b-c">
            <span>机构登录</span>
          </div>
        </a>
        <a
          rel="noreferrer"
          :href="hyEntryLink"
          title="会员登录"
          target="_blank"
          class="login-entry-pop-item"
        >
          <h3>会员登录</h3>
          <div class="hover-txt-box f-b-c">
            <span>会员登录</span>
          </div>
        </a>
      </div>
    </el-dialog>

    <el-dialog
      title="选择相应系统注册"
      :visible.sync="dialogVisibleRegister"
      custom-class="login-entry-dialog"
      width="930px"
      top="25vh"
    >
      <div class="login-entry-pop f-c">
        <a
          rel="noreferrer"
          href="https://www.ejy365.com/register"
          title="国有资产交易"
          target="_blank"
          class="login-entry-pop-item1 mr-20"
        >
          <h3>国有资产交易</h3>
          <div class="hover-txt-box f-b-c">
            <span>国有资产交易</span>
          </div>
        </a>
        <a
          rel="noreferrer"
          href="https://www.ejy365.com/register"
          title="自然资源交易"
          target="_blank"
          class="login-entry-pop-item1 mr-20"
        >
          <h3>自然资源交易</h3>
          <div class="hover-txt-box f-b-c">
            <span>自然资源交易</span>
          </div>
        </a>
        <a
          rel="noreferrer"
          href="http://www.hljnjzx.com/#/home/home"
          title="农村产权交易"
          target="_blank"
          class="login-entry-pop-item1 mr-20"
        >
          <h3>农村产权交易</h3>
          <div class="hover-txt-box f-b-c">
            <span>农村产权交易</span>
          </div>
        </a>
        <a
          rel="noreferrer"
          href="https://purchase.hljygcg.com:10000/login"
          title="阳光招标采购"
          target="_blank"
          class="login-entry-pop-item1"
        >
          <h3>阳光招标采购</h3>
          <div class="hover-txt-box f-b-c">
            <span>阳光招标采购</span>
          </div>
        </a>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { NAV_MENU_CODE } from "@/utils/constant";
import BlockHeadLine from "@/views/home/components/BlockHeadLine.vue";
import { mapGetters } from "vuex";
export default {
  name: "LoginEntry",
  components: { BlockHeadLine },
  props: {
    // patientIn: {
    //   type: Object,
    //   default () {
    //     return {}
    //   }
    // }
  },
  data() {
    return {
      dialogVisiblejy: false,
      dialogVisiblecg: false,
      dialogVisiblezy: false,
      dialogVisibleRegister: false,
      code: NAV_MENU_CODE.CZZN,
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["allMenusList"]),
    cgrEntryLink() {
      return process.env.VUE_APP_CGR_LINK;
    },
    gysEntryLink() {
      return process.env.VUE_APP_GYS_LINK;
    },
    dljgEntryLink() {
      return process.env.VUE_APP_DLJG_LINK;
    },
    zjEntryLink() {
      return process.env.VUE_APP_ZJ_LINK;
    },
    jgEntryLink() {
      return process.env.VUE_APP_ENTRY_JG_LINK;
    },
    hyEntryLinkjy() {
      return process.env.VUE_APP_LOGIN_LINK;
    },
    hyEntryLink() {
      return process.env.VUE_APP_ZRZY_LINK;
    },
    zzcgEntryLink() {
      return (
        this.allMenusList.find((item) => item.code === NAV_MENU_CODE.CZZN)
          ?.path || ""
      );
    },
    zjzcEntryLink() {
      return process.env.VUE_APP_ENTRY_ZJZC_LINK;
    },
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {},
};
</script>

<style scoped lang="scss">
.login-entry {
  .login-entry-head {
    border-bottom: 2px solid #eee;
    h3 {
      font-size: 16px;
      font-weight: bold;
      line-height: 2;
      position: relative;
      &::after {
        content: "";
        display: block;
        width: 100%;
        height: 2px;
        background-color: $--color-primary;
        position: absolute;
        bottom: -2px;
        left: 0;
      }
    }
    .register-btn {
      width: 70px;
      height: 20px;
      border-radius: 9px;
      border: 1px solid $--color-primary;
      color: $--color-primary;
      text-align: center;
      line-height: 18px;
      font-size: 12px;
      &:hover {
        text-decoration: none;
        background-color: $--color-primary;
        color: #fff;
      }
    }
  }
  ul {
    li {
      width: 80px;
      height: 90px;
      border-radius: 4px;
      text-align: center;
      background: #fdf9ed;
      & + li {
        margin-left: 10px;
      }
      & + li:nth-child(2) {
        background: #fff3ed;
      }
      & + li:nth-child(3) {
        background: #edfdfc;
      }
      & + li:nth-child(4) {
        background: #fff3f4;
      }
      & + li:nth-child(5) {
        background: #e5f1ff;
      }
      a {
        display: block;
        position: relative;
        width: 100%;
        height: 100%;
        img {
          width: 24px;
          height: 24px;
          margin: 18px 0 0 0;
        }
        &:hover {
          img {
            opacity: 0.8;
          }
        }
        span {
          color: #333;
          font-weight: bold;
          font-size: 14px;
          position: absolute;
          left: 12px;
          top: 52px;
        }
      }
      &.quickly-item {
        width: 150px;
        height: 80px;
        border: 1px solid #ddd;
        &:hover {
          border-color: $--color-primary;
          opacity: 0.8;
        }
        a {
          display: flex;
          flex-flow: column;
          align-items: center;
          justify-content: center;
          img {
            height: 28px;
            width: 28px;
            object-fit: contain;
          }
          span {
            position: static;
            transform: none;
            font-size: 14px;
            font-weight: bold;
            line-height: 1;
            padding-top: 10px;
          }
        }
      }
    }
  }
}
.login-entry-pop {
  width: 100%;
  height: 280px;
  .login-entry-pop-item {
    width: 200px;
    height: 250px;
    display: block;
    position: relative;
    overflow: hidden;
    &:first-child {
      background: url("@/assets/images/home/login-entry-pb.jpg") no-repeat
        center / cover;
    }
    &:last-child {
      background: url("@/assets/images/home/login-entry-kb.jpg") no-repeat
        center / cover;
    }
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0;
      transition: opacity 0.4s;
      position: absolute;
      left: 0;
      top: 0;
    }
    h3 {
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      padding-left: 20px;
      position: absolute;
      left: 0;
      bottom: 40px;
      transition: transform 0.25s;
      z-index: 2;
      &::after {
        content: "";
        display: block;
        width: 60px;
        height: 6px;
        border-radius: 3px;
        background-color: $--color-primary;
        position: absolute;
        left: 20px;
        bottom: 0;
        transform: translateY(15px);
      }
    }
    .hover-txt-box {
      width: 100%;
      height: 100%;
      //background-color: rgba(0,0,0,0.4);
      position: absolute;
      left: 0;
      top: 0;
      padding: 15px;
      transform: translateX(-100%);
      transition: transform 0.5s;
      z-index: 999;
      span {
        color: #fff;
        font-size: 14px;
        line-height: 1.5;
      }
    }
    &:hover {
      // h3{
      //   transform: translateY(200px);
      // }
      // .hover-txt-box{
      //   transform: translateX(0);
      // }
      &:after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.4;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1; // 背景层的 z-index
      }
    }
  }
  .login-entry-pop-item1 {
    width: 200px;
    height: 250px;
    display: block;
    position: relative;
    overflow: hidden;
    &:first-child {
      background: url("@/assets/images/home/login-entry-cgr.jpg") no-repeat
        center / cover;
    }
    &:nth-child(2) {
      background: url("@/assets/images/home/login-entry-gys.jpg") no-repeat
        center / cover;
    }
    &:nth-child(3) {
      background: url("@/assets/images/home/login-entry-dljg.jpg") no-repeat
        center / cover;
    }
    &:nth-child(4) {
      background: url("@/assets/images/home/login-entry-zj.jpg") no-repeat
        center / cover;
    }
    &:after {
      content: "";
      display: block;
      width: 100%;
      height: 100%;
      background-color: #000;
      opacity: 0;
      transition: opacity 0.4s;
      position: absolute;
      left: 0;
      top: 0;
    }
    h3 {
      font-size: 18px;
      color: #fff;
      font-weight: bold;
      padding-left: 20px;
      position: absolute;
      left: 0;
      bottom: 40px;
      transition: transform 0.25s;
      z-index: 2;
      &::after {
        content: "";
        display: block;
        width: 60px;
        height: 6px;
        border-radius: 3px;
        background-color: $--color-primary;
        position: absolute;
        left: 20px;
        bottom: 0;
        transform: translateY(15px);
      }
    }
    .hover-txt-box {
      width: 100%;
      height: 100%;
      //background-color: rgba(0,0,0,0.4);
      position: absolute;
      left: 0;
      top: 0;
      padding: 15px;
      transform: translateX(-100%);
      transition: transform 0.5s;
      z-index: 999;
      span {
        color: #fff;
        font-size: 14px;
        line-height: 1.5;
      }
    }
    &:hover {
      // h3{
      //   transform: translateY(200px);
      // }
      // .hover-txt-box{
      //   transform: translateX(0);
      // }
      &:after {
        content: "";
        display: block;
        width: 100%;
        height: 100%;
        background-color: #000;
        opacity: 0.4;
        position: absolute;
        left: 0;
        top: 0;
        z-index: 1; // 背景层的 z-index
      }
    }
  }
}

::v-deep {
  .login-entry-dialog {
    .el-dialog__body {
      padding-top: 0;
    }
  }
}
</style>
